import React from 'react';
import {ChevronRight, Hand, Heart } from 'lucide-react';

export default function Services() {
  const services = [
    {
      icon: Hand,
      title: "Rheuma",
      description: "Umfangreiche Diagnostik und Therapie von rheumatischen Erkrankungen",
      items: [
        "Erkankungen: chronische Polyarthritis, Psoriasisarthritis, entzündliche Wirbelsäulenerkrankungen- Spondylarthropathie/Morbus Bechterew, Kollagenosen wie Systemischer Lupus erythematodes, Systemische Sklerose, Dermatomyositis etc, reaktive Arthritis, Arthrosen, Vaskulitis, Polymyalgia rheumatica, Fibromyalgie, Gicht, Osteoporose", 
        "Interdisziplinäre Zusammenarbeit mit Hausärzten, Fachärzten, Radiologieinstituten und Krankenhäusern", 
        "Ultraschalluntersuchung der Gelenke",
        "Befundbesprechung und strukturierte Therapieplanung, detaillierter Arztbrief für den Hausarzt und auf Wunsch auch für den Patienten"
      ]
    },
    {
      icon: Heart,
      title: "Innere Medizin",
      description: "Moderne Diagnostik mit neuester Medizintechnik",
      items: [
        "Allgemein internistische Untersuchung mit Anamnese, klinischer Untersuchung, Therapieeinstellung, Labor, EKG", 
        "Ultraschalluntersuchung Herz (Echokardiographie) , Bauchorgane , gehirnversorgende Arterien, periphere Arterien, Rippfell/Lunge", 

      ]
    }
  ];

  return (
    <section id="leistungen" className="services">
      <div className="services-container">
        <div className="section-header">
          <h2 className="section-title">
            Unsere Leistungen
          </h2>
          <p className="section-description">
            Umfassende medizinische Versorgung mit modernster Ausstattung und individueller Betreuung
          </p>
        </div>
        <div className="services-grid">
          {services.map((service, index) => {
            const IconComponent = service.icon;
            return (
              <div key={index} className="service-card">
                <div className="service-icon">
                  <IconComponent color="white" size={32} />
                </div>
                <h3 className="service-title">
                  {service.title}
                </h3>
                <p className="service-description">
                  {service.description}
                </p>
                <ul className="service-list">
                  {service.items.map((item, i) => (
                    <li key={i}>
                      <ChevronRight 
                        className="service-list-icon" 
                        size={30} 
                      />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}